import {EventBroker} from "@frontend/lib/utils/event-broker";

export const IDML_IMPORT_EVENTS = {
  SELECT_LAYOUT: 'IDML_IMPORT_SELECT_LAYOUT',
};

export const importIDMLEventBroker = new EventBroker();
